import { UpdatePasswordComponent } from "./views/update-password/update-password.component";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { LeafletModule } from "@asymmetrik/ngx-leaflet";
import { Ng2SearchPipeModule } from "ng2-search-filter";

import {
  LocationStrategy,
  HashLocationStrategy,
  CommonModule,
  DatePipe,
} from "@angular/common";
import { OwlDateTimeModule, OwlNativeDateTimeModule } from "ng-pick-datetime";
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxMaskModule } from "ngx-mask";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { MatButtonModule } from "@angular/material/button";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatListModule } from "@angular/material/list";
import { EnvServiceProvider } from "./service/Bindingurlservice/bindingurl.service.provider";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { NgbModule, NgbDateParserFormatter } from "@ng-bootstrap/ng-bootstrap";
import { AppComponent } from "./app.component";
import { HeaderComponent } from "./views/header-component/header.component";
import { HeaderGroupComponent } from "./views/header-group-component/header-group.component";

import { LoginComponent } from "./views/login/login.component";
import { ForgetPasswordComponent } from "./views/forgetPassword/forgetPassword.component";

import { companyPolicyComponent } from "./views/cookies/companyPolicy";
import { privacyPolicyComponent } from "./views/cookies/privacyPolicy";
import { ActionRendererComponent } from "./views/actionsRenderer/action.component";
import { EquipmentCmdActionRendererComponent } from "./views/actionsRenderer/equipmentCmdAction.component";
import { AlarmHistoryActionRendererComponent } from "./views/actionsRenderer/alarmsHistoryAction.component";
import { CustomReportActionComponent } from "./views/actionsRenderer/customAction.component";

import { SiteListActionRendererComponent } from "./views/actionsRenderer/siteListAction.component";
import { SiteListRendererComponent } from "./views/siteListing/siteListRenderer.component";
import { SiteListAccessRendererComponent } from "./views/siteListing/siteListAccessRenderer.component";
import { alarmStatusrenderer } from "./views/siteListing/alarmstatus.component";
import { AlarmRendererComponent } from "./views/alarmRenderer/alarmRenderer.component";
import { AlarmHistoryRendererComponent } from "./views/alarmHistory/alarmHistoryRenderer.component";
import { AdditionalDetailsRendererComponent } from "./views/additionalDetailsRenderer/additionalDetailsRenderer.component";
import { DetailedSiteListRendererComponent } from "./views/detailedSiteListRenderer/detailedSiteListRenderer.component";
import { NgbDateFRParserFormatter } from "./ngb-date-fr-parser-formatter";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AlarmsComponent } from "./views/alarms/alarms.component";
import { AlarmHistoryComponent } from "./views/alarmHistory/alarmHistory.component";
// import { CsvExportModule } from "@ag-grid-community/csv-export";
// import { ExcelExportModule } from "@ag-grid-enterprise/excel-export";
// import { MasterDetailModule } from "@ag-grid-enterprise/master-detail";

ModuleRegistry.registerModules([
  // ClientSideRowModelModule,
  // CsvExportModule,
  // ExcelExportModule,
  // MasterDetailModule
]);
const isIE =
  window.navigator.userAgent.indexOf("MSIE ") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1;
const APP_CONTAINERS = [
  LoginComponent,
  ForgetPasswordComponent,
  DefaultLayoutComponent,
  UpdatePasswordComponent,
];
// import {
//   // AppAsideModule,
//   SidebarModule,
//   BreadcrumbModule,
//   HeaderModule,
//   FooterModule,
// } from "@coreui/angular";
import { AppRoutingModule } from "./app.routing";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { TabsModule } from "ngx-bootstrap/tabs";
import { ChartsModule } from "ng2-charts";
import { Globals } from "./globals";
import { HttpService } from "./service/HTTPService/HttpService";
import { HighchartsChartModule } from "highcharts-angular";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { MatNativeDateModule } from "@angular/material/core";
import { CookieLawModule } from "angular2-cookie-law";
import { ArchwizardModule } from "angular-archwizard";
import { AlarmlegendsComponent } from "./views/alarmlegends/alarmlegends.component";
import { ApiService } from "./service/apiUrls/apiUrl.service";
import { AuthInterceptorService } from "./service/auth-interceptor/auth-interceptor.service";
import { SharedModule } from "./Utils/shared/shared.module";
import { LoggingService } from "./service/LoggingService/loggingService";
import { ModuleRegistry } from "ag-grid-community";
import { DefaultLayoutComponent } from "./containers/default-layout/default-layout.component";
import {
  MsalGuard,
  MsalInterceptor,
  MsalBroadcastService,
  MsalInterceptorConfiguration,
  MsalModule,
  MsalService,
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalGuardConfiguration,
  MsalRedirectComponent,
} from "@azure/msal-angular";
import { BrowserCacheLocation, InteractionType, IPublicClientApplication, PublicClientApplication } from "@azure/msal-browser";

const clientID = (window as any).__env.azureClientID;
const tenantID = (window as any).__env.azureTenantID;
const redirectUri = (window as any).__env.azureRedirectUri;
export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: clientID,
      authority: `https://login.microsoftonline.com/${tenantID}`,
      redirectUri: redirectUri,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
      storeAuthStateInCookie: isIE
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return { 
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['user.read']
    }
  };
}


@NgModule({
  imports: [
    BrowserModule,
    MsalModule,
    FormsModule,
    NgSelectModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatButtonModule,
    Ng2SearchPipeModule,
    MatToolbarModule,
    MatListModule,
    LeafletModule.forRoot(),
    PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    ArchwizardModule,
    ChartsModule,
    CommonModule,
    HttpClientModule,
    NgbModule,
    HighchartsChartModule,
    DragDropModule,
    NgxSpinnerModule,
    NgxMaskModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    MatNativeDateModule,
    CookieLawModule,
    SharedModule,
  ],
  declarations: [
    AppComponent,
    companyPolicyComponent,
    privacyPolicyComponent,
    ...APP_CONTAINERS,
    HeaderComponent,
    HeaderGroupComponent,
    ActionRendererComponent,
    EquipmentCmdActionRendererComponent,
    AlarmHistoryActionRendererComponent,
    CustomReportActionComponent,
    AlarmRendererComponent,
    DetailedSiteListRendererComponent,
    AlarmHistoryRendererComponent,
    AdditionalDetailsRendererComponent,
    SiteListActionRendererComponent,
    SiteListRendererComponent,
    alarmStatusrenderer,
    SiteListAccessRendererComponent,
    AlarmlegendsComponent,
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    { provide: NgbDateParserFormatter, useClass: NgbDateFRParserFormatter },
    Globals,
    DatePipe,
    HttpService,
    AlarmsComponent,
    AlarmHistoryComponent,
    EnvServiceProvider,
    ApiService,
    LoggingService,
    MsalService,
    MsalGuard,
    MsalBroadcastService,
  ],
  bootstrap: [AppComponent,MsalRedirectComponent],
})
export class AppModule {}
